
import { ElMessageBox, ElButton, ElIcon, Action, MessageBoxState, Callback } from "element-plus";
import { defineComponent, onMounted, ref, markRaw } from "vue";
import { FormActions } from './../../Store/index';
import { useStore } from "vuex";
import { navigateToStepWithRouterLink } from './../../Composables/form';

  export default defineComponent({
    name: "ModalComponent",
    components: {
      ElButton,
      ElIcon
    },

    props: {
      btnTitle: String,
      btnClass: String,
      classDiv: String,
      customClass: String,
      title: String,
      size: String,
      iconBefore: String,
      iconAfter: String,
      iconPathBefore: String,
      iconPathAfter: String,
      type: String,
      buttonType: String,
      body: String,
      confirmButtonText: String,
      confirmButtonClass: String,
      cancelButtonText: String,
      cancelButtonClass: String,
      showConfirmButton: Boolean,
      showCancelButton: Boolean,
      openModalWithoutButton: {
        type: Boolean,
        default: false
      },
    },

    setup(props) {
      // Get the Vuex store instance
      const store = useStore();

      const iconProps = [props.iconBefore, props.iconAfter],
          size = props.size ?? 'default',
          type = props.type ?? '',
          buttonType = props.type ?? 'link',
          showConfirmButton = props.showConfirmButton ?? true,
          showCancelButton = props.showCancelButton ?? false;

      let circle = false,
          round = false,
          plain = false,
          link = false;

      switch (buttonType) {
        case 'circle':
          circle = true;
          break;
        case 'round':
          round = true;
          break;
        case 'plain':
          plain = true;
          break;
        case 'link':
          link = true;
          break;
        default:
          link = true;
          break;
      }

      const handleMessageBoxCallback = (action: Action, valueOrInstance: string | MessageBoxState): void => {
        // hide result page
        if (action === 'cancel' && typeof valueOrInstance === 'object' && 'cancelButtonClass' in valueOrInstance && valueOrInstance.cancelButtonClass.includes('vehicle-detail-close-button')) {
          navigateToStepWithRouterLink(store, 1, 'start');
          store.dispatch(`form/${FormActions.SET_SHOW_RESULT_PAGE}`, false);
        }
      };

      const open = () => {
        ElMessageBox.alert(props.body, props.title, {
          customClass: props.customClass ?? '',
          cancelButtonText: props.cancelButtonText ?? 'Close',
          cancelButtonClass: props.cancelButtonClass ?? 'primary',
          showConfirmButton: showConfirmButton,
          showCancelButton: showCancelButton,
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          callback: handleMessageBoxCallback as Callback,
        })
      }

      // Assuming iconComponents is an object
      const iconComponents = ref({});
      onMounted(async () => {
        if (iconProps && Array.isArray(iconProps) && iconProps.length > 0) {
          try {
            const module = await import(`@element-plus/icons-vue`);
              iconProps.forEach((component) => {
                if (component !== undefined && module[component]) {
                  iconComponents.value[component] = markRaw(module[component]);
                }
              });
          } catch (error) {
              console.error(`Failed to load icon component`);
          }
        }
      });

      if (props.openModalWithoutButton) {
        open();
      }
      
      return {
        circle,
        round,
        plain,
        link,
        size,
        type,
        iconComponents,
        open
      }
    }
  })
